{
  "/2UAr8": "Kontaktfält",
  "/5CHlX": "Logga in med ett till konto på samma enhet",
  "/5QnNV": "Nu kan tavlor kopplas till den här skärmen!",
  "/7rdrt": "Avvikelser",
  "/9x0Cy": "Medarbetare",
  "/AM2jq": "Kunde inte uppdatera roll",
  "/b67I8": "Inmatningsläge för skärm",
  "/bg+F+": "Fortsätt Senare",
  "/DKRdc": "Lär dig mer",
  "/eiyWM": "Redigera Signal",
  "/eTxM+": "Aktiva avvikelser",
  "/fMF0b": "Förhandsvisning",
  "/i++KH": "Ändra namn",
  "/Ia8aK": "Kontaktinformation",
  "/ITUJ4": "Snitt",
  "/Iu5Ln": "Enheter",
  "/kDxbC": "Storleken går inte att ändra eftersom rutan delas mellan flera tavlor",
  "/MTrTe": "Alla {categoryTitle} som är tilldelade dig visas här.",
  "/MXSaU": "Frånvarande",
  "/NGg8l": "Butiksnamn",
  "/NPOoW": "Är du säker på att du vill ta bort det här spacet?",
  "/nYVIK": "Roller",
  "/o2bmm": "Logga in med e-post och lösenord",
  "/PJfbx": "Välj avdelning",
  "/pY820": "Enheter",
  "/Q/I4N": "Färg",
  "/RXaxf": "Innan du kan logga in behöver du verfiera din e-postadress genom att klicka på länken i din e-post.",
  "/tA0wh": "Total",
  "/tAquW": "Adress",
  "/U+OG+": "Fortsätt",
  "/ufig8": "Alla filer",
  "/yB9f3": "Möt och hjälp kunder ute i butik. Vid lågt tryck åtgärda avvikelser från dagrundan.",
  "++KExP": "Organisationslogga",
  "+1SaIo": "Bildspel",
  "+AO5di": "Avdelningstyp",
  "+brboA": "Redigera Körschema",
  "+bW2fQ": "Välj checklistor",
  "+CQrj/": "Tillåt StoreSprint att lägga in bilder",
  "+e3NTc": "Organisations-admin",
  "+GqH6O": "Checklista: {totalTaskExecutionCount, plural, =1 {# kontrollpunkt} other {# kontrollpunkter}}",
  "+hhKwP": "{categoryName} - Avdelningar",
  "+ie+vc": "Ta bort kategori",
  "+j+Hv+": "Tid till löst",
  "+Jmv6A": "Utgå från en av mallarna eller skapa en helt egen. Det är enkelt att ändra innehållet i tavlan.",
  "+jy6WZ": "Radera och flytta till Att Göra",
  "+K6n6J": "Den titel som presenteras mot kund.",
  "+KFKGK": "Väder",
  "+N4wv2": "Avsluta",
  "+NqUPp": "Arkiverade att göra",
  "+oSQY3": "Vill du ta bort mätområdet {name}?",
  "+oUdhz": "Är du säker på att du vill ta bort {roleName}? Den här åtgärden kan inte ångras.",
  "+RLlYv": "Lägg till delad enhet",
  "+RmmiH": "Namn på underavdelning",
  "+SZ1cG": "Exempelavdelning",
  "+UIQl1": "Storecast Space",
  "+Vku1c": "Skapar butik",
  "+X4kcT": "Ändra",
  "+yjU26": "Schemalägg",
  "01cOAp": "Godkänn åtkomst till bilder för StoreSprint",
  "01ynrj": "Ange text...",
  "03XJDN": "Ändra namn på maskiner",
  "04SvJU": "Din att göra kommer att publiceras direkt till valda enheter.{br}Vänligen kontrollera att innehållet är korrekt innan du fortsätter. ",
  "05UM6K": "Påminnelse skickad",
  "06iKNT": "Ett Storecast Space är en dedikerad yta på butikstavlorna som kontrolleras centralt inom ert workspace. Här kan ni enkelt lägga till och ta bort widgets samt uppdatera innehållet. Alla ändringar synkroniseras automatiskt med Storecasts på enheterna.",
  "08Ps73": "Tillgänglig för iOS och Android på telefon och surfplatta",
  "0b9yvL": "Konvertera",
  "0BDeYb": "Ladda ner QR-kod",
  "0blbHv": "{seenCount}<washed>/{totalCount}</washed> Användare",
  "0gXORY": "Lägg till deadline",
  "0hJsJ9": "Sök efter användare",
  "0hvKwW": "Meddelande",
  "0jw3Wa": "Workspace",
  "0k55xH": "Kistra in token här",
  "0kJtbg": "För att lägga till en ny skärm behöver vi skanna QR-koden. Gå in i appen via mobil eller surfplatta för att göra detta!",
  "0KtANW": "Alla {categoryTitle} som är skapade av dig visas här.",
  "0KUtBO": "Slutförd på",
  "0lMi9d": "Butiksnamn",
  "0lML7t": "Lägg till delad enhet",
  "0MkEQX": "Schema",
  "0NzNpO": "Inga produkter kvar",
  "0OtZRg": "Bekräfta att du vill radera {todoCategoryName}. {totalCount} aktiviteter kommer raderas. Skriv {todoCategoryName} i textfältet och tryck OK.",
  "0pCjN0": "Sök användare",
  "0qbjZ+": "Skärmstatus",
  "0Rp8+O": "Visa hemsida",
  "0RtRBq": "Okej",
  "0RWzjW": "Status",
  "0U8hT+": "Radera händelse",
  "0UB8uo": "Tack för din feedback!",
  "0Xg9H9": "Tilldela kostnadsställen till avdelningar. Schemat från HR-systemet kommer automatiskt synkas. Samma kostnadställen kan tillhöra flera avdelningar.",
  "0Ynbm5": "Alla {categoryTitle} som är tilldelade dig och hör till {teamName} visas här.",
  "1+sU4n": "Avdelningarna som kommer få kundinputen.",
  "11g1wa": "Vald",
  "11HupH": "Tackmeddelande",
  "11mumD": "Open Email App",
  "144f86": "Radera \"{title}\"",
  "14kK4q": "Namn",
  "15C0Zf": "Låst ämne",
  "1CRgrd": "Avdelningen har inga månadsrutiner.",
  "1DLk3s": "Arkivering flyttar denna att göra till arkivet och tar bort den från alla mottagarenheter.",
  "1eHWGR": "All sektioner",
  "1FJMIQ": "Välj underschema",
  "1iBKuD": "Lägg till bild från bibliotek",
  "1kKysa": "Den här veckan",
  "1MrFkL": "Ditt namn",
  "1UYvPO": "Radera denna användare",
  "1WwiG+": "Redigera roller",
  "1WWnOc": "De valda avdelningarna kommer att följa upp den här rutinen",
  "1XxugU": "Välj avvikelseansvarig ",
  "2/uHVE": "Skapa ny butik",
  "21MU/Z": "Överlämning",
  "221xBq": "Ange text",
  "2414HE": "Tid",
  "27D95a": "Näst sista dagen",
  "28NNgR": "Radera mall",
  "29vtuR": "Mer än",
  "29yAgV": "URL",
  "2Bwa9x": "Bildbibliotek",
  "2CI7Bp": "Publicera till {storeCount, plural, one {1 enhet} other {# enheter}}",
  "2csuuS": "Aktivitet",
  "2dV8iL": "Heldag",
  "2Eupph": "Skärmar",
  "2fLC3L": "Veckodagar",
  "2gHWWx": "Du har gjort ändringar som inte är sparade än, vill du spara dessa?",
  "2iUWcs": "Osparade ändringar, spara för att visa ändringar",
  "2NVuHy": "Arkivera Signal",
  "2P5r1s": "Storecast-Spacet kunde inte skapas. Försök igen.",
  "2qHVUH": "Deluppgifter",
  "2r6kx4": "Aktiv idag",
  "2RhFm9": "Laddar ner uppdatering",
  "2Sn3Kq": "Organisera dagens, veckans och månadens rutiner här.",
  "2t7JeE": "Frivillig",
  "2TrYwN": "Mottagare",
  "2tXL3B": "Ordna sektioner",
  "2VaFGP": "Koppla skärm",
  "2xrUso": "Användare",
  "3+z5gp": "All historik som samlats in från det här nyckeltalet kommer tas bort",
  "30QIaF": "Ändra",
  "32er4H": "Nyligen uppladdade",
  "33CcKR": "Plånboksöppnare",
  "34ONx2": "Körscheman",
  "34QKrq": "Kategorinamn",
  "361uD/": "Vem kommer att använda inkorgen?",
  "36ZmLE": "Skapa Connect-inkorg",
  "3788Xn": "Skapa konto utan medarbetare",
  "3ajXXo": "Ni kan göra det direkt från mobilen eller via datorn genom att surfa in på StoreSprint.app och logga in med ett adminkonto!",
  "3DZl8O": "Skapa Workspace",
  "3EPqIg": "Du är på väg att skicka en notis till alla enheter som inte har svarat.",
  "3gEzTp": "Gör om till personligt konto",
  "3GRKZv": "Inställningar",
  "3hKUGD": "Utgångsdatum",
  "3HOmh+": "Publiceringsdatum",
  "3hvaLL": "Bjud in användare",
  "3KDcFV": "Välj ansvarig avdelning",
  "3KWQQG": "Endast läsning",
  "3l1BiU": "Lägg till integration",
  "3L4tp7": "Listformat",
  "3ldZ6s": "Välj avdelning att skapa underavdelningar på",
  "3LW/4Z": "Datum",
  "3M93by": "Kan döljas lokalt",
  "3oFR06": "Förslag",
  "3RN6B5": "Skapa butik",
  "3ssLlB": "Logga in som delad enhet",
  "3Udf7f": "Tid",
  "3vgXcq": "{seenCount}<washed>/{totalCount}</washed> Medarbetare",
  "3vNxfP": "Text",
  "3voTVq": "Konvertera till gruppkonto",
  "3w/eGg": "Schemaläggning",
  "3w+zQU": "Här bjuder du in användare till din butik! Den du bjuder in kommer få ett mail och kan via det skapa sitt konto med ett eget lösenord och är sedan redo att hoppa in i butiken!",
  "3yB8zp": "Kontrollpunkter",
  "3YLyne": "Alla checklistor",
  "3zlgRf": "Att göra-lista",
  "3zYoRw": "Du kan inte återställa ett Space efter att den har raderats. Spacet kommer att raderas från samtliga tavlor.",
  "4/kkEE": "Heldag",
  "4++Khw": "Anpassa",
  "40zBi1": "Vänligen vänta medan administratören godkänner din förfrågan.",
  "45VGKx": "Denna kontrollpunkt kommer endast att vara synlig för enheter som är tilldelade till detta ämne. Om ett eller flera avdelningar prenumererar på ämnet, kommer avvikelser som skapas i denna kontrollpunkt automatiskt att delas till de avdelningarna.",
  "4745Ds": "Sugen på att använda kassaläget? Få tillgång till en digital PLU-bok med bilder och smart sökfunktion. Ni kan enkelt lägga till nya artiklar med bild och PLU via mobilen eller datorn. Kontakta vår support, så hjälper vi er komma igång!",
  "4aAdck": "Ogiltigt telefonnummer",
  "4EvH1I": "Uppladdad av",
  "4gRio8": "Radera medarbetare",
  "4h+k3N": "Engelska",
  "4IJO9g": "Kort hälsning som visas i större text",
  "4IYTBB": "Visa hela körschemat",
  "4LBbNb": "Förhandsgranska",
  "4LTaVP": "Skapa ny butik",
  "4mvw9n": "Välj plats",
  "4NA4YY": "Inkorgar för kunder",
  "4oIOP2": "Alla filer",
  "4QFaa3": "Redigera Laguppställning",
  "4qpE3l": "Scanna in",
  "4r/x/7": "Ordna uppgifter",
  "4shFIb": "Det saknas en skärm som din tavla kan kopplas till.",
  "4t7yGI": "Sortera: ",
  "4tmJxz": "Är du säker på att du vill avaktivera integrationen?",
  "4U+ajP": "Nästa vecka",
  "4UNvXt": "{count, plural, one {Inkluderar ett workspace under} other {Inkluderar # workspaces}}",
  "4wEn3w": "Sök",
  "4WUKdV": "Namn",
  "4Xr7rQ": "Nu",
  "4Zqkd5": "Frånvaroorsaker",
  "4zSBzW": "Checklistor skapade från {routineName}",
  "4ZyP8k": "Skapelsedatum",
  "5+QU1m": "Installera skärm",
  "50eneR": "Översikt",
  "52cFSi": "Er hemsida har just nu ingen välkomsttext",
  "52U1sD": "Se över veckans nyheter och ändringar. Veckovis.",
  "53bZW/": "Veckoblad",
  "53Swj1": "Anpassad",
  "56ixyX": "Telefon",
  "56OL4N": "Nuvarande version: v{version} - {createdAt}",
  "5bglMn": "Avbryt",
  "5CjMXa": "Lägg till",
  "5FEDHv": "Skapa tavla",
  "5gpkFu": "Streckkod",
  "5hco4l": "Skapade",
  "5kbeA2": "Roller",
  "5lM0pY": "Fyll i veckans värde",
  "5OL9xg": "Ange nummer...",
  "5QYydA": "Radera",
  "5s2Hkc": "Inbjudan har passerat giltighetstiden. Skicka en ny för att fortsätta!",
  "5tyRe/": "Kom igång",
  "5Viqt2": "Användaren kan ange sitt namn eller anställnings-ID",
  "5w7VMt": "Skapa gruppkonto",
  "5WlY2S": "Varje Dag",
  "5xngWR": "Avbryt publicering",
  "5y4dOo": "Okej",
  "5ZZOuK": "Veckodag",
  "6/42ru": "Den valda avdelningen blir tilldelad alla avvikelser från sektionen",
  "6/XSXe": "Historik",
  "61ogfj": "Fortsätt redigera",
  "69FNNK": "Sortera eller dölj funktioner på avdelningsskrämen för att enklare hålla fokus på rätt saker.",
  "6beFo9": "Analys (Förhandsvisning)",
  "6bZnrv": "Email",
  "6ccTTW": "Organisations-användare",
  "6DIve2": "Slutförd",
  "6fZEpG": "Kom igång med PLU",
  "6HGPXY": "Sektioner",
  "6jjygR": "Skanna för att öppna produkt",
  "6krr48": "Något gick fel",
  "6LJoSl": "Skapa mall i workspace",
  "6MlJfy": "Prio",
  "6O2TcW": "Aktivera Funktioner",
  "6slbmO": "Radera kommentar",
  "6T5gWp": "Avvikelse",
  "6UFIR8": "Ge tillgång till bilder",
  "6V5lYt": "Nyheter i appen!",
  "6Y7uSh": "Tillgång",
  "6ZQKPj": "Filen är öppnad totalt {accessedCount} gånger av {accessUsersCount} användare.",
  "7/m6W7": "Väntar på godkännande",
  "70KEAG": "Hanterade",
  "70SE8E": "Avdelningar",
  "710Ive": "Vill du skapa en mall från denna rutin i workspace rutinbiblioteket?",
  "73UFkX": "Spara för att aktivera startsida",
  "753wxz": "Skapa och tilldela uppgifter till valda eller alla enheter inom ditt workspace, anpassa med instruktioner, prioritet, svarskrav och deadlines, och följ framstegen i realtid. Börja med att utforma och publicera när du är klar.",
  "7EGpO+": "Titel",
  "7FP5Fh": "Avvisa",
  "7gj7RE": "Låt StoreSprint använda kameran",
  "7gyp9t": "Rubrik för widget",
  "7ieVH2": "Kunde inte skapa roll",
  "7KDxGX": "Visas ovanför kontaktformuläret",
  "7o5L7s": "Bearbetar",
  "7onLo7": "Konton",
  "7P58TV": "Välj Tavla",
  "7sB59n": "Kom igång!",
  "7SRl5r": "Skapa underavdelning",
  "7svu7g": "Vanligaste beskrivningarna av avvikelser senaste 30 dagarna",
  "7sybTh": "Veckorutiner",
  "7xhToS": "Startdatum",
  "7yFdNT": "Behöver tillgång till bilder",
  "7Zh53g": "Deadline",
  "7ZTkfs": "Lösenord",
  "7zYuJV": "Din att göra kommer att schemaläggas och publiceras till valda enheter vid inställd tidpunkt.{br}Vänligen kontrollera att innehållet är korrekt innan du fortsätter.",
  "8/RXzP": "Schemalägg fler tavlor",
  "81RPqg": "Du har osparade ändringar.  Är du säker på att du vill gå tillbaka utan att spara?",
  "8A/aO7": "Att Göra - Avdelningar",
  "8b+fai": "Rekommenderad",
  "8CStZE": "Arkivera",
  "8jPIa4": "Ordna sektioner",
  "8n2OEe": "StoreSprint Connect",
  "8pIw9O": "Logga in",
  "8qpVx/": "Skyltning",
  "8Sssvh": "Bra jobbat!",
  "8SWoh7": "Du har inget skapat",
  "8W9fW8": "Välj kontrollpunkter",
  "8wIuwg": "Det verkar vara ett problem med internetanslutningen. Kontrollera att din enhet är ansluten till internet.",
  "8XXuHC": "Kunde inte radera roll",
  "8y4415": "Filter",
  "8ZKeJu": "Bildsvar krävs för att lämna in",
  "8ZqZIG": "Upplösning",
  "8zXvGO": "Imorgon 15:00",
  "9+h6Q9": "Välkomstmeddelande",
  "96FQWf": "Kom igång",
  "98i/wB": "Är du säker på att du vill radera denna kategori?",
  "9b+RoA": "Plats",
  "9ci2nW": "Andel åtgärdade avvikelser inom given tidsperiod",
  "9DAVZ3": "Skärmar",
  "9e1z/L": "Organisationsnamn",
  "9F3TmK": "Ladda ner QR-kod",
  "9fMLWT": "Roller",
  "9h6TXC": "Anpassa listan genom att välja listformat och filtrering av avdelningar.",
  "9HBwYW": "Tilldela avdelningar",
  "9hkK+E": "Sök",
  "9HL650": "Skapa en ny tagg",
  "9hNj9h": "Alla orsaker",
  "9htGVC": "Hur många avvikelser rapporteras per vecka",
  "9iQHnT": "Menyprio",
  "9jmwDC": "Senast kontrollerad {time}",
  "9Lccv7": "Välj avvikelseansvarig",
  "9lHWC6": "Slutdatum",
  "9LoX5p": "Skapa en tavla",
  "9LxCQj": "{todoCategoryTitle} ej raderad",
  "9LY27e": "Redan installerat en skärm? Är den påslagen med internetanslutning och inne på hemsidan storecast.app?",
  "9NyiR5": "Vecka",
  "9pzDOg": "Skicka",
  "9Qt9Z3": "ICA Min Butik",
  "9qTl2y": "Klar!",
  "9rUBTK": "Widgets",
  "9Tl6PZ": "Radera utkast",
  "9VJmFo": "Updatera på {count} StoreCast",
  "9w+fPB": "Dagens positiva",
  "a+1cuO": "Misslyckas",
  "a0gwEX": "Checklista",
  "A2R999": "Skapa en tavla med information som rör hela butiken.",
  "a7rJtq": "Skapa medarbetare",
  "A9E7kT": "Mätområden",
  "a9YFQb": "En tavla hjälper till att visualisera bland annat nyckeltal, aktiviteter, avvikelser, dagens positiva. Tavlan skräddarsys utefter behoven och går att visas på flera skärmar. ",
  "aAD1+G": "Avvikelser",
  "aAldnC": "Avbryt",
  "aB0Kmk": "Prenumerera på extern kalender",
  "aCnlU8": "Radera",
  "acprAM": "Skapa konto utan medarbetare",
  "AcxqTO": "{value, plural, one {# händelse} other {# händelser}}",
  "Ag7nFc": "Oläst",
  "aghAfA": "Notifikation",
  "agZ02K": "Ange siffra",
  "AhGJaP": "Hjärtat i driften.",
  "AhI5OV": "Livsmedelsbutik",
  "AiJ/wi": "Aktiv kampanj",
  "AIKAr2": "Användarnamn",
  "AIpZOE": "Rutinbibliotek",
  "ajlpIV": "Avlänka medarbetare",
  "aJr+ZP": "{installedStoresCount}/{storesCount} Butiker, {installedDashboardsCount} Tavlor",
  "AKG3m7": "Delade enheter",
  "alFXXy": "Ändra profil",
  "alT0/e": "Nyckel för extern tjänst skapad",
  "AmkYTX": "Check",
  "amqUVq": "Koppla en tavla",
  "aOch1u": "Installera skärm",
  "aOdAiy": "Inställningar",
  "AOxKAW": "Inbjudan skickad",
  "ApDUzW": "Tom",
  "at25ob": "Personalutrymmen",
  "ATuPZK": "Kontor",
  "AuX8L7": "Logga ut",
  "AV9QUd": "Välj filter",
  "axFDrw": "Tilldela behörighet",
  "aXSUTq": "Radera {roleName}",
  "AXUN29": "Kontrollpunkter",
  "AZPIN2": "Välj den att göra-lista som ska ta emot kundens input",
  "b+eD2n": "Titel",
  "b0a90Y": "Kunde inte skapa avdelning",
  "B1G5y+": "Välj vilka avdelningar som ska få kundinputen",
  "B1xNzb": "Skapade",
  "b73yMJ": "Bjud in",
  "B9Nxz0": "Nummersvar krävs för att lämna in",
  "Ba1CfC": "Se mer",
  "BadU3n": "Ta bort bild",
  "baMPat": "Välkomstmeddelande",
  "Bb1P0I": "Aktivera Schema",
  "bbkeFX": "Tilldela kostnadsställen",
  "bBRR96": "Vanligaste Avvikelser",
  "bBsKft": "Vill du ersätta ditt nuvarande innehåll med den valda mallen, inklusive beskrivning, filer och bilder?",
  "BBYPVt": "Lägg till produkt",
  "BCaf7H": "Välj minst 1 aktiv vecka",
  "BcBPiP": "Välj Text & Bild att lägga till",
  "BCgkJo": "{name} är skapad!",
  "BdGMF5": "Händelse",
  "BDmt8u": "Startklar!",
  "bEKkvN": "Skärmnamn",
  "BffEdd": "Radera StoreCast",
  "BHHbpY": "Utan HR",
  "bHoyw3": "Installera ny skärm",
  "BI0wOD": "Välj sektioner",
  "BiCjpY": "Fel",
  "BII/4s": "Översikt",
  "BiYl9E": "Det angivna namnet skiljer sig från {todoCategoryTitle}",
  "bjSejJ": "Administrera Workspace",
  "Bk1D0d": "Ta en kort avstämning med kvällspersonal inför kvällen.",
  "BkEX3I": "Idag 15:00",
  "BLsgo8": "Är du säker på att du vill arkivera kalendern?",
  "bMaBSd": "Nyckeltalets namn",
  "BMEPkm": "Spara",
  "bMLupe": "Rensa filter",
  "BN0nvd": "Alla mätområden",
  "bngzsR": "All produkter som tillhör denna kategori kommer också raderas.",
  "bNIdJw": "{unreadCount, plural, one {# Oläst} other {# Olästa}}",
  "BQNmiJ": "Kunde inte spara namnet",
  "BrhVKO": "Mail till användare",
  "BsG/g2": "{count, plural, one {Gruppkonto} other {Gruppkonton}}",
  "BT8kyn": "Radera",
  "btEGJJ": "Arkiverade kalendrar",
  "Bth6UU": "Prenumerationslänk",
  "BTYdxK": "{numOfTasks} av {maxNumOfTasks} kontrollpunkter valda",
  "buykc7": "Veckor",
  "BvRfs2": "Svar",
  "bwijo7": "Kom igång med körschemat",
  "bxHeV3": "Anpassa Avdelning",
  "byC49t": "Schemalagd",
  "BylAJR": "Ladda upp filer här för att göra dem tillgängliga för en, flera eller alla enheter inom valt workspace.",
  "bypsUE": "Rikta kameran mot QR-koden!",
  "BzqW+b": "Dold",
  "BzXexR": "Redigera nyckeltal",
  "c308bK": "Visar laguppställning med medarbetare",
  "C6e4wY": "Bjud in användare",
  "c6lDdd": "Inställningar",
  "c6ztUh": "{storeName} har inga checklistor som är skapade från {routineName}",
  "c9BUH1": "Butik",
  "CAEXOs": "Misslyckades med att ställa in roller",
  "CAHeuj": "Schemalagd för publicering: {formattedDate}",
  "cC/Qs9": "Ordna",
  "Cc16TP": "Hela avdelningen",
  "CCGZFI": "Ansvariga",
  "cChSTK": "Roll",
  "CCSaiF": "En enhet med namnet {nameSuggestion} har begärt att logga in.",
  "ce/AW6": "Fokusläge gör det enkelt och mer interaktivt att ha möten vid tavlan. Tryck på en widget för att förstora den.",
  "Ce0ekU": "Udda",
  "ceF4Vc": "Inga data",
  "CEh/Dz": "Inga sökresultat",
  "cFR8S4": "Inga {categoryTitle}",
  "Ch71Ic": "Publicera",
  "CIBLe2": "HR",
  "CKdFT/": "Tom mall",
  "ckgHkI": "Slutar",
  "cKvEzr": "Dags för kassaläge?",
  "CnFMLx": "Tilldelade roller",
  "CNiWyy": "Bjud in användare",
  "CNjYAk": "Rubrik...",
  "Co3LqX": "Avvikelseansvarig:",
  "cOIEor": "Dela QR-kod",
  "coO36e": "Mottagare",
  "cpkUIX": "Är du säker på att du vill ta bort denna inkorg? Alla länkar och QR-koder som är kopplade till denna inkorg kommer att sluta fungera.",
  "cr81dI": "Lägg till widget",
  "CRBTKa": "Missad kontrollpunkt",
  "CSebLK": "Duplicera",
  "CsRLbM": "Välj medarbetare",
  "CueN95": "{count, plural, one {# avdelning} other {# avdelningar}}",
  "CUXZab": "Historik",
  "cuzSoH": "Medarbetare",
  "cV89re": "Strålande insats från Karin igår!! \uD83D\uDC4F",
  "CvWvOz": "Notis skickad",
  "cW1Sp3": "Vi kände inte igen QR-koden som du har skannat. Kontrollera att du är inne på storecast.app i din skärm, samt testa att refresha sidan en gång innan du försöker igen.",
  "cWnW6j": "Ändra händelse",
  "CxjNTI": "Lägg till gamla uppgifter",
  "CxV45J": "Misslyckades med att bjuda in användare",
  "CzYYZq": "Alla orsaker",
  "d/f9nx": "Bekräfta att du vill radera {todoCategoryName}. {totalCount} aktiviteter kommer raderas.",
  "D1fayT": "Gruppkonton",
  "d1K1eL": "Gruppkonto",
  "D3IDgL": "Alla Signaler",
  "d3LHbu": "Tackmeddelande",
  "D3Qo62": "Hjälp",
  "d5l/6h": "Standard",
  "D6h1wW": "Ämne",
  "d7dyMB": "Kategori",
  "d7sUkv": "Sparar",
  "D8gPxD": "Välj ett namn för denna användare. Det kommer synas för dig och dina kollegor på olika ställen i StoreSprint",
  "da8X4e": "Flytta till lista",
  "dBFh6m": "Aktiv senaste dagarna",
  "dbq2nb": "Ny exponering inne",
  "DC0Dba": "Välj målgrupp",
  "dc70vR": "Workspace och roller",
  "dCb8X2": "Ta bort integrationen",
  "ddxis3": "Fortsätt senare",
  "DenwS7": "Misslyckas",
  "deYR0i": "Öppnad {openedAtFormatted}",
  "dfaYeF": "Taggar",
  "dfgSIL": "Anpassa listan genom filtrering av avdelningar.",
  "DFZMAG": "Publiceringsdatum",
  "DGjkST": "Kopiera länken till ditt veckoblad och klistra in nedan",
  "dHuruW": "Händelser",
  "di0DKC": "Skapa ett Storecast Space",
  "DIAzij": "Namn",
  "diMnN8": "Kunde inte prenumerera på kalendern",
  "DiT6A0": "Avbryt",
  "DjWM8z": "Tips!",
  "DLdEAV": "Mottagare",
  "DlwBjl": "Beskrivning",
  "dMfxUD": "Pantmaskiner",
  "DnB4xb": "Namnlös Butik",
  "dNBQLu": "Mer än",
  "dnCZTT": "Är du säker på att du vill radera bilden?",
  "dPt67u": "Befintlig",
  "DpTw+p": "<b>{missingOccasions}</b> missade förra veckan",
  "DpzEAM": "Skriv ett produktnamn för att börja söka.",
  "dQt82d": "Välj vilken Aktivitetskategori som ska exponeras",
  "DRZ+sT": "För att filen ska kunna visas behöver vi söka igenom den. Det kan ta mellan 1-2 minuter från det att den laddades upp.",
  "dsEdbm": "Bocka av",
  "Dtqrec": "Färdig! {name} är skapad!",
  "DTWplB": "Visa sida",
  "DUd4WC": "Bekräfta att du vill radera {todoCategoryName} och flytta innehållet till Att Göra. {totalCount} aktiviteter kommer flyttas till Att Göra. Skriv {todoCategoryName} i textfältet och tryck OK.",
  "DvlkMy": "Nyckeltalen hjälper er att enkelt få en översikt på exempelvis “svinn” och “hål i hyllan”. Utifrån dessa går det att se var förbättringar kan ske.",
  "dWUWPX": "Mallar",
  "DX4Z8y": "Eller gör det sen",
  "DXGcZB": "Alla arkiverade att göra",
  "dXU10a": "Skicka och markera som besvarad",
  "dxU3XB": "Avdelningar",
  "dykg/S": "Det går utmärkt att ändra rubrik och innehåll i en widget efter att den har skapats",
  "dyVgVa": "Missad frivillig kontrollpunkt",
  "Dz8pck": "Avancerat",
  "Dzsb6K": "Ett fel inträffade, se till att du har rätt kod",
  "e/wqVO": "Det gick inte att spara nytt namn",
  "e0J8cg": "Din tavla är kopplad till de här skärmarna.",
  "E0QeKx": "Vill du ta bort denna widget?",
  "E4BZ84": "Här samlas alla enheter inom valt workspace. Genom att klicka på en enhet kan du teleportera dig till deras vy och se operativ status i realtid. Du behöver ha admininstratörsbehörighet för att skapa nya enheter.",
  "e63712": "Ett fel uppstod",
  "E7XPE8": "Skanna med delad enhet",
  "eArJCC": "Personuppgifter",
  "eAxrfs": "Flytta till en annan lista",
  "eaZWko": "Ett email har skickats till:",
  "eBsPQb": "Ingen kontroll",
  "EcC0nA": "{count, plural, one {Personal} other {Personal}}",
  "Edzha5": "Visa sida",
  "EEWJCe": "Avdelningen har inga veckorutiner.",
  "efWRtW": "Kassaläge",
  "EfZjUp": "Välj vilka skärmar som ska visa denna tavla",
  "EFZKij": "{numberOfPages, plural, one {1 sida} other {# sidor}}",
  "eHl8nK": "Arkivera direkt",
  "EhqRDd": "Skapa ny mall från nuvarande innehåll",
  "EhZGPk": "Bildbibliotek",
  "EIptUw": "Radera",
  "eiw/LM": "E-post",
  "EJkzV8": "Kan jobba med StoreSprint i den dagliga driften.",
  "ejVmDv": "Schemalägg",
  "ElKzyn": "Du har fått ett mail!",
  "em9vok": "Redigera namn",
  "EoYLCQ": "Veckoblad",
  "ePU4cQ": "Kommer synas på samtliga enheter och visualiseras extra kraftfullt både på Storecast och i appen.",
  "EpvjLu": "För närvarande finns det inga produkter med utgångsdatum.",
  "es2sS6": "Konto",
  "ETbgQF": "Textsvar krävs för att lämna in",
  "eUdFWX": "Gör om till veckorutin",
  "EUdyTL": "Adress",
  "EUwUUB": "Sparad <date>{editedAtDate}</date> av {editedByName}",
  "evgeRS": "Gör om till gruppkonto",
  "evzMEE": "Din signal kommer att schemaläggas och publiceras till valda enheter vid inställd tidpunkt.{br}Vänligen kontrollera att innehållet är korrekt innan du fortsätter.",
  "EwT6yU": "Saknar åtkomst till kamera",
  "ex1BCt": "Redo att ladda upp",
  "eydq6Y": "Avarkivera \"{routineTitle}\"",
  "eYJVOl": "För många filer",
  "ezqBQn": "Skapa en tavla med information från en eller flera avdelningar.",
  "F0Def9": "{count} produkter",
  "F1JMmX": "Välkommen till StoreSprint",
  "F3p+EC": "Här syns alla avvikelser som har tilldelats dig.",
  "F4mThf": "Användare",
  "f7coX9": "Skapa personligt konto",
  "FbkHkO": "Saknas",
  "FcfYH5": "Avaktivera Checklista",
  "FD98cD": "Se över veckans nyheter. Uppdatera skyltar och exponeringar.",
  "FdgB6H": "Misslyckades att skicka notifikation",
  "FDh70A": "Det angivna namnet skiljer sig från {todoCategoryTitle}",
  "FDW8Cz": "Skapa en tavla",
  "feLblT": "Inga användare hittade",
  "FGsAzX": "StoreSprint behöver tillgång till kameran",
  "fH1I6V": "Lägg till taggar",
  "FhBxSS": "Taggtitel",
  "fHE3Lc": "Vill du ta bort sektionen?",
  "FHgHME": "{count} i lager",
  "FidGMx": "Redigera layout och widgets",
  "FIy6wH": "API-nyckel",
  "fJ08Wy": "Filen processas",
  "fjXGos": "Utvecklare",
  "fL4eZP": "Ämnen",
  "FMg80B": "Skapa händelse",
  "fMk4lk": "Tryck på ändra för att lägga till innehåll",
  "FMRzhA": "Ange koden manuellt",
  "FNLTA/": "Klistra in en länk till din",
  "fNp0fd": "Aktivera startsida",
  "fNUzYg": "Sidor",
  "FO4jjv": "Dagligen",
  "fo5CyK": "Checklista Butik ",
  "FPRwdN": "Hela butiken",
  "fPSYwA": "Redigera ämne",
  "FQNt8D": "Du kan nu fylla Storecast-Spacet med widgets. Utforska olika layouter och håll innehållet uppdaterat.",
  "FR0GMh": "Höjdpunkt",
  "frigSE": "Gå tillbaka utan att spara",
  "FRLNoB": "Visa de senaste utfallen för en kontrollpunkt.",
  "Fs9XU9": "Bra jobbat {name} {emoji}",
  "fSOrxU": "Ej schemalagd",
  "Ft+OgK": "Ser allt korrekt ut? Ändra inställningar på skärmen om någonting inte stämmer.",
  "FuGJET": "Visa arkiverade avdelningar",
  "fuNuzS": "Snart",
  "FUQxeB": "Namn",
  "Fv+uB6": "Tilldela",
  "FVDKW9": "Inställningar",
  "fvKJov": "{categoryName}-lista",
  "fwmWH3": "Pantrum",
  "Fwviq8": "Email",
  "Fx0RNf": "Taggtitel",
  "Fyv9jo": "Kommentarer",
  "Fz90K2": "Radera Nyckeltal",
  "g//kGm": "Prenumerera på kalender",
  "g/0RpT": "Detta representerar det allokerade området på butikens tavla där du kan placera widgets.",
  "g/3c7J": "Avdelningar",
  "G/m3LU": "Kontaktinformation",
  "G1fhiL": "Att göra",
  "g1IuDB": "Radera",
  "G1oFN2": "Roll",
  "G1or4I": "Välj",
  "G2HUbt": "Är du säker på att du vill logga ut från den här enheten?",
  "G4IIyJ": "Skapa ny mall",
  "G7SJPX": "Tavlans namn",
  "gbFcY5": "{todoCategoryTitle} redo att lämnas in",
  "GbNbYH": "Arkiverad",
  "GdPN+x": "Gör om till gruppkonto",
  "gDRZnp": "Nyhetsflöde",
  "gDs1C+": "Dagliga Rutiner",
  "GeOgG+": "Ändra butiksnamn",
  "geqD5D": "Utan roll",
  "GfWTu/": "Publicera att göra ",
  "Ggb2Wn": "Fyll i förra veckans värde",
  "GGgt76": "När det finns en signal att se, visas den här!",
  "ghnNq1": "Idag 22:00",
  "GhV+JF": "Aktiva skärmar",
  "Gk7Ouc": "Förhandsgranska sida",
  "GKKgkt": "Anpassade Listor Admin",
  "GlDND0": "Namn",
  "gMbdbF": "Svar",
  "gMWl/r": "Delade enheter",
  "gNTxST": "Gå till Checklista",
  "gOcgfk": "Bildbibliotek",
  "gOFCPk": "Kontrollpunkt",
  "GojC6I": "Online broschyr",
  "GpI6Z9": "Valuta",
  "graOHR": "{count, plural, one {# orsak} other {# orsaker}}",
  "Gsgz/3": "Dela QR-kod",
  "gSL70Y": "Hantera integrationer",
  "gsLrF9": "Skicka Push-notiser",
  "GSQX+h": "Vissa saker är bättre att hålla i en separat lista. Här kan du skapa anpassade listor för olika typer av att-göra-uppgifter, till exempel förbättringar, kundförfrågningar eller långsiktiga uppgifter.",
  "GTl7kp": "Arkiverade Signaler",
  "GtMThF": "Aktivera mål",
  "gubIqG": "välj datum",
  "GWpket": "Storlek {height} x {width}",
  "GWrBC3": "Aktivitetskategori",
  "GxeQeN": "Skapa Enhet",
  "GxfWvZ": "Snart klar!",
  "gXx1uf": "Inga tilldelade avdelningar",
  "Gyj0mH": "Dölj produkt",
  "GZ0J7Z": "Återanslut",
  "gzLdHp": "Behöver tillgång till bilder",
  "GZPtAD": "Ställ in mål",
  "h1/shw": "Svarstyp",
  "h24wRv": "{routineName} används inte i {storeName}",
  "H2oFoq": "Radera \"{title}\"",
  "H40KVK": "Namn",
  "H5ptUc": "Visar dagens rutiner tillsammans med en summering av aktuella vecko- och månadsrutiner.",
  "H63bVD": "Radera bild",
  "h6GxYq": "Nu går det att lägga till widgets i tavlan och anpassa innehållet till era behov.",
  "H9/uqf": "Välj kontrollpunkter att lägga till i sektionen.",
  "HaLVT1": "Signaler",
  "HbIzTZ": "Skärmstatus",
  "hbXssb": "Bocka av för att lämna in",
  "HCIKJc": "Antal avvikelser per kontrollpunkt",
  "Hdo3TG": "Kassalinjen",
  "Hff+Yp": "Roller",
  "hfjXFB": "Uppdatera länk",
  "hhn3vH": "Låst avdelning",
  "hIesVA": "Slutförda",
  "hiTEoC": "Sektioner",
  "Hiwlsk": "Välj avdelningar som ska bli tilldelade.",
  "Hk7vmO": "Körschema",
  "HKJqMH": "Att göra-lista",
  "hKmie0": "Laddar upp",
  "hLf0pw": "Välj kalender",
  "Hn5FRO": "Redigera deluppgift",
  "HObwGC": "Koppla till skärm",
  "hQMNCv": "StoreSprint Connect",
  "hVOYNZ": "Avdelningsnamn",
  "HwqBw4": "Lägg till din kontaktinformation så att kunder kan kontakta er.",
  "HxQrP2": "Beskrivning",
  "HYqK03": "När du raderar en användare tas alla personuppgifter relaterade till denna användare bort från denna butik. Notera att detta ej går att ångra. Det innehåll som användaren skapat raderas inte. GDPR: Detta är en tillräcklig åtgärd vad gäller att radera personlig information i förhållande till gällande GDPR-lagstiftning. Användarens tillgång till butiken tas bort inom 24 timmar.",
  "HYTd0B": "Är du säker på att du vill radera \"{title}\"?",
  "HZjKWn": "{todoCategoryTitle} ej raderad",
  "hzLLfn": "Kunde inte spara",
  "i44FBU": "Kom igång med nyckeltal!",
  "i5LBOM": "Inaktiv",
  "i6Hrse": "Senast Öppnad",
  "I9NmVl": "När ska nyckeltalet fyllas i?",
  "IbhIBt": "Välj mätområden",
  "ibIr7z": "Attribut",
  "iCMaJw": "Min sida",
  "IEMUqT": "Tid till åtgärd",
  "ies7R1": "Välj dom taggar som automatiskt ska tilldelas kundinputen. Tryck på en tagg för att växla om det ska tilldeles eller inte.",
  "iffFK2": "Ta bort integration",
  "IG5vdg": "{completedStores}/{totalStores} butiker",
  "IGmguI": "Kopiera",
  "IgnuQZ": "Skapa ny inkorg",
  "II/VfK": "Publicerad",
  "IiIjg9": "Att konvertera denna användare till ett gruppkonto kommer att göra det möjligt för dig att hantera flera användare under ett enda konto. Detta är användbart för att hantera ett team av anställda eller för att skapa ett delat konto för en grupp användare.",
  "iIlwgW": "Är du säker på att du vill radera kalendern?",
  "IJA8Is": "Användare",
  "IK5ljL": "Radera",
  "IlsH2u": "Föregående",
  "ImFT7H": "Tidzon",
  "INY1xF": "Enhet",
  "iOh64S": "Ladda upp filer här för att göra dem tillgängliga för en, flera, eller alla enheter inom det aktuella arbetsutrymmet.",
  "iQJqyb": "Mina butiker",
  "iqqo/I": "Aktivitet över dagen",
  "IR3KbX": "Ny",
  "ITRS+A": "Välj användare eller logga in",
  "Iuvyv/": "Butikens Tavla",
  "IuXELI": "Skapa ny tagg",
  "IW+D1u": "Mindre än",
  "IWDlBY": "Ta bort integration",
  "iwXhGp": "Sektionsnamn",
  "IxefOR": "Inställningar",
  "ixN07K": "Alla butiker & avdelningar",
  "iXRQ+6": "Färger som redan används för andra taggar",
  "IynrNm": "Grön eller Röd",
  "j1jRNO": "Dölj detaljer",
  "j1kC66": "Gå in på storecast.app i TVns webbläsare innan nästa steg.",
  "J2xdJx": "Lägg till datum",
  "j3f7B9": "Integrationer",
  "j5n5bI": "Välj en skärm att visa i fokusläge.",
  "J5OHzz": "Redigera namn & ikon",
  "j6c8oP": "Historik",
  "J7oDM8": "Aktiva integrationer",
  "j8IQXD": "Touch",
  "j8ryNQ": "Gäst",
  "J9D1nl": "Arkiverad avdelning",
  "JakbE6": "Slutar {value}",
  "JBJB8T": "Vill du skapa en mall med befintligt innehåll, inklusive beskrivning, prioritet, bilder och filer?",
  "jD3Wsy": "Avdelningsnamn",
  "je+4Bs": "Arkivera avdelning",
  "JfdCg/": "Avbryt",
  "jfnYZm": "T.ex. \"Beskriv ditt första intryck i entrén.\"",
  "Jg2t6l": "Radera användare",
  "Jgkcku": "Tilldelade",
  "jIJU5r": "Det här kommer att göra om rutinen till en veckorutin. Veckorutiner kan bara göras en gång i veckan. Vill du fortsätta?",
  "jiPGts": "Skapa nyckeltal",
  "jlz86Y": "Godkänn",
  "jmWt+0": "Licensnummer",
  "Jn5WcQ": "Är du säker på att du vill avarkivera rutinen?",
  "jS7nRU": "Din signal kommer att publiceras direkt till valda enheter.{br}Vänligen kontrollera att innehållet är korrekt innan du fortsätter. ",
  "jsfGbP": "Kom igång!",
  "jtq5ol": "Välj Kategori",
  "JTr5Gk": "Lägg till widget",
  "JuvDAP": "Alla",
  "JVqXMO": "Kedjeinfo",
  "jWJoWm": "Nummer",
  "Jwm+Sl": "Din butik är redo!",
  "JXCgJu": "Använd annan skärm",
  "jYjuXU": "Rutiner",
  "JyPack": "Vill du ersätta ditt nuvarande innehåll med den valda mallen, inklusive beskrivning, filer och bilder?",
  "k/K+iK": "Radera",
  "k/owmH": "Schemalägg signal till {storeCount, plural, one {1 enhet} other {# enheter}}",
  "K/VD2/": "Ta bort produkt",
  "K1Rv0I": "Rubrik för widget",
  "k301v0": "En ny butik har nu skapats!",
  "k4YagF": "Avdelningstavla",
  "k5QaKQ": "{count, plural, one {Personal+} other {Personal+}}",
  "k73jGK": "Ett fel inträffad när avdelningen skulle uppdateras",
  "k76k8Q": "Visa arkiverade",
  "K86c/+": "Kontonamn",
  "kaLx2I": "Radera alla kontrollpunkter innan checklistan kan ändras.",
  "KaWikF": "Lägg till händelse",
  "Kbnf7A": "Tomra Inställningar",
  "Kc5PJF": "Arkivera \"{title}\"",
  "keeKoQ": "Skicka notis",
  "Kg93VL": "Välj lista",
  "KGBAPw": "Ange koden du fick från en administratör.",
  "khGqSA": "Skanna kod",
  "kiMVod": "Status",
  "kiw97p": "Datum och tid ",
  "kizdg7": "Checklistan har inte några kontrollpunkter med svarstyp Grön- och Röd check",
  "kjOP1o": "Schemalagda Storecasts",
  "kkeJ81": "Anpassa widget",
  "Kkvqx7": "Checklistor",
  "kLWobd": "Skapa ämne",
  "KMpYQb": "Att arkivera denna signal kommer att ta bort den från din lista över aktiva signaler, men den kommer inte att raderas permanent. Du kan fortfarande komma åt den i arkivet senare. Vill du fortsätta med att arkivera?",
  "kMvjC5": "Siffra",
  "kmYvAE": "Skicka nu",
  "KN92/r": "Är du säker på att du vill radera \"{title}\"?",
  "knhw5p": "Skicka en påminnelse till ansvariga",
  "kNLy/7": "Publicera signal",
  "KOg9Oe": "Anpassa",
  "kq67JN": "Redigera Körschema",
  "kR385T": "Lägg till konto",
  "krBsws": "Helger",
  "KrMG/z": "Är du säker på att du vill ta bort den här användaren?",
  "KSfO73": "Länkat",
  "KtqLSd": "Personligt konto",
  "KU1hsB": "Ogiltig EAN8",
  "KUFB9r": "Vi kunde inte hitta en produkt med denna EAN-kod.",
  "KuqGzk": "En beskrivning av den externa aktiviteten för kunden.",
  "kvl5aH": "Lägg till Kalender",
  "kvpxvG": "Kom igång med en mall",
  "KwVx60": "Centralstyrda checklistor",
  "KxfEi8": "Tavlor med text & bild",
  "KxlFTc": "Lägg till befintlig",
  "kxloRM": "Jämna",
  "KxpHXC": "Vardagar",
  "ky0Gjp": "Välkomstmeddelande",
  "L/aT7H": "Alla filer",
  "L+7NaZ": "Se fullständig instruktion",
  "l+MezR": "Radera lista",
  "l8GDbW": "Status",
  "L8PJEZ": "Kontrollera att URL:en är korrekt",
  "L9D0Qd": "{count} kontrollpunkter",
  "L9dOY+": "Genom att koppla tavlan till en skärm går det att visa den på skärmen via Storecasten.",
  "L9VeNr": "Storecast",
  "LA4TAx": "Är du säker på att du vill radera denna medarbetare?",
  "LAJpJo": "Vill du ta bort den här sidan?",
  "lAOuAK": "Du har inget tilldelat",
  "lbl0r+": "Börja skriva för att söka efter filer!",
  "lCMnnw": "Taggar",
  "lDv+fg": "Checklista",
  "LeId8v": "Skapa kalender",
  "leWQ+3": "Avvikelser (beta)",
  "lfgy3K": "Den aktivitetskategori som kundinputen kommer komma till.",
  "lFK8dR": "Hem",
  "LFxkbl": "Avarkivera avdelning",
  "Lg8DLM": "Utesluten kontrollpunkt",
  "Lg8dRC": "Är du säker på att du vill ta bort den här bilden?",
  "lgnVK9": "Är du säker på att du vill radera {title}?",
  "LH9rfO": "ICA Min Butik",
  "LhboI5": "Acceptera autentiseringsförfrågan",
  "lhxeSu": "Månadsvis",
  "llE7SP": "Text & Bild",
  "lnfe6w": "Välj",
  "LPBqfM": "PushAppy Inställningar",
  "lpD4JF": "Radera skärm",
  "Lpne3D": "Sektionsnamn",
  "LpPbxP": "Välj en färg som bäst representerar ditt varumärke. Färgen kommer att användas för knappar och text.",
  "LQdh1y": "{title} minskade med {percent}% förra veckan jämfört med veckan innan",
  "LqSwHp": "Ett meddelande som presenteras för kunden efter att hen har lämnat ett meddelande.",
  "lqVRx/": "Norska",
  "lR38uK": "Välj enhet",
  "lTHy6C": "Butiksnamn",
  "lujOv0": "Skapa underavdelning",
  "lvA3GY": "Skapa nyckeltal",
  "LvUYmS": "Ogiltig EAN13",
  "lWfoOL": "Välj",
  "LX+SMC": "Inga avvikelser tilldelade dig!",
  "Ly/aq0": "Är du säker på att du vill radera filen?",
  "LyOdjh": "Starta fokusläge",
  "lzIdt2": "Varumottagning",
  "LzLb8Y": "Sista dagen i månaden",
  "LZt1+k": "Aldrig",
  "m/pq+6": "Välj aktiva veckor",
  "m+sP3O": "Fyll i gårdagens värde",
  "m1+0YL": "Avdelningen har inga dagliga rutiner.",
  "m1H2U7": "Status",
  "m3prso": "Behöver tillgång till kameran",
  "m4Bfsp": "Filnamn",
  "m4fuwy": "För att använda storecast, gå in på storecast.app i TVns webbläsare. Fortsätt i appen på din mobil eller surfplatta.",
  "m6kbt7": "Följ upp om rutinen är avklarad",
  "M83o9g": "Fritext & bild",
  "M8cmLb": "Gör om till gruppkonto",
  "m9M0x5": "Får ej plats",
  "m9Oi8O": "Behörigheter",
  "MaofQM": "Aktiva dagar:",
  "maUhcC": "Symboler",
  "mAvFYw": "Lämna en kommentar...",
  "mbh0/7": "Radera konto",
  "mE2PXf": "Upphör om {expiresIn}",
  "me3kg2": "Tillbaka",
  "ME8mIm": "Statusöversikt (Förhandsvisning)",
  "mFJfBr": "{count} taggar",
  "MFRZyj": "Kunder",
  "MFYY1j": "Är du säker på att du vill ta bort denna skärm?",
  "mila3E": "Admin",
  "miT6nR": "Namnet på inkorgen som kommer att visas för användaren.",
  "MjiXzm": "Ge uppgifen ett mål. Det kommer synas där uppgiften utförs och visuellt i grafer.",
  "MJLW5P": "Lämna in senare",
  "mjwX9c": "Taggar",
  "mL4758": "Bjud in användare",
  "mLNUW9": "inom {value} {value, plural, =1 {timme} other {timmar}}",
  "MLT4F5": "Schemalägg att göra till {storeCount, plural, one {1 enhet} other {# enheter}}",
  "mlZ4K5": "Som Personal, men kan även göra ändringar i checklistor samt administrera filer.",
  "mo0LVH": "Email",
  "mo3QuX": "Roller",
  "mp4FH4": "Ta bort widget",
  "mPOYZy": "Ditt namn",
  "mPpN5+": "Svenska",
  "MpUuVB": "Avbryt",
  "mqnoHf": "Lägg till utgångsdatum",
  "mR4sxU": "Ändra utgångsdatum",
  "MroCDL": "{title} ökade med {percent}% förra veckan jämfört med veckan innan",
  "mrSSGd": "Avdelningar och Taggar",
  "MSeDmq": "Butiksnamn",
  "muS2xs": "Du har inte tillgång till några organisationer",
  "mUuJWa": "Lägg till utgångsdatum",
  "mV/+qD": "Externa tjänster",
  "mvfLnp": "Skapa underavdelning",
  "mVIGNH": "Skapa tagg",
  "mVYX04": "Uppdatera token",
  "MXADeD": "Vill du verkligen radera ditt utkast? När det är borttaget går det inte att återskapa.",
  "mzHLYE": "Inbjudan skickad",
  "mzPmcs": "Administrera kostnadsställen",
  "N0x9pV": "Namnge nyckeltal",
  "N3mR1y": "Länka produkt",
  "n3RmOY": "Överge ändringar?",
  "n6uEWl": "Ett fel inträffade",
  "n6waOs": "Radera detta space",
  "Naiyx9": "Endast läsning",
  "NAl4zU": "Skanna för att lägga till utgångsdatum",
  "NAxLYh": "Butiken har ingen avdelning",
  "NbkJHq": "Morgonmöte",
  "Nbv3hn": "Ta bort roll",
  "nclPD5": "Under",
  "NDObQV": "Anpassat datum & tid",
  "nDsM5N": "Individuella konton",
  "nE85v+": "Privat avdelning",
  "NEI4XZ": "Körschema",
  "nGeaYp": "Tavlor med space",
  "NGMCb3": "Beskrivning som kan vara något längre, kommer att visas med mindre text",
  "ni4tYs": "Att hantera",
  "Nir/CM": "Skapa attribut",
  "NKQcnC": "Layout",
  "NlsadS": "Avdelningar",
  "nm2zzR": "Avbryt",
  "nnlmaQ": "Radera utgångsdatum",
  "NnYYFz": "Kopiera länk",
  "NOPv/l": "Alla",
  "nOyAzw": "Tilldela ämne",
  "nPwVbz": "Alla {categoryTitle} som är tilldelade dig och hör till {teamName} visas här.",
  "nq53lo": "Externa tjänster",
  "nrFG6g": "Länkad medarbetare saknas",
  "Nrgq39": "Rest",
  "Ns4N8r": "Skapa underavdelning",
  "nsEMDz": "Är du säker på att du vill radera detta utgångsdatum?",
  "NSfhRd": "Skapa tagg",
  "nsL8jS": "Schemalagd för publicering: {formattedDate}",
  "NTqhJl": "Lägg till integration",
  "nUwgeM": "Medarbetare",
  "Nvt6oN": "Arkivera",
  "Nw+9oZ": "Primär",
  "nwvpAs": "Uppladdad",
  "NwyBSx": "Signaler",
  "nY5V3a": "Målgrupp",
  "NYVE6P": "Roll",
  "NzdRoc": "Vy",
  "O/0R7p": "{selectedStoreCount}/{totalStoreCount} enheter",
  "O/McQp": "Öppnad",
  "o0TZLJ": "Sortera eller dölj funktioner på avdelningen",
  "O2LviD": "Länkad",
  "O3RQBI": "Radera {todoCategoryName}",
  "o5YUk7": "Inbjudna användare",
  "o67t2t": "Varuplock",
  "oAk5jc": "Ta bort bild",
  "oAURGx": "Instagram-länk",
  "obLCw5": "Ansvarig Avdelning",
  "OcGIj5": "Skapa ny mall från nuvarande innehåll",
  "OdE8JC": "Samla in anställds identitet",
  "ODKho5": "slutförde",
  "Oeggoi": "Välj avdelningar",
  "oeiygQ": "Hål i hyllan",
  "ofTNvr": "Gruppkonto",
  "ogj0iO": "Bjud in",
  "OgKM1U": "Dela QR-kod",
  "OGTr7+": "Ta bort kontrollpunkt",
  "OJ/N89": "Öppna Storesprint på den delade enheten och välj \"Logga in som delad enhet\"",
  "okYqZD": "Kopiera länken till din pushappy-skärm",
  "oLCLin": "Gå ett varv i butiken och notera avvikelser på respektive avdelning.",
  "oLsQ3p": "Får ej plats",
  "OmErpL": "1. Gå in på inställningar (kugghjulet upp i högra hörnet).{newLine}2. Välj \"Kalender\" i menyn till vänster.{newLine}3. \"Delade kalendrar\".{newLine}4. Under rubriken \"Publicera en kalender\" väljer ni vilken kalender som ska länkas och \"Kan visa all information\".{newLine}5. Tryck på \"Publicera\".{newLine}6. Tryck på ICS och kopiera.{newLine}7. Klistra in länken här.",
  "ON5Rl9": "Avmarkera alla",
  "onEntA": "Ni kan tänka på dessa som sorterade brevlådor med anpassade etiketter för olika typer av aktiviteter. Exempelvis: \"Kundönskemål\", \"Att göra\" eller \"Förbättringsförslag\"",
  "onh9fL": "Ta bort widgeten från denna Tavlan?",
  "Oq/J/b": "Ändra avdelning",
  "OQ9W4P": "Storlek",
  "oqXMMV": "Sökningen gav inget resultat",
  "org-admin-topics-create-topic": "Skapa ämne",
  "ORH45g": "Schemalägg Storecast",
  "ORwHEa": "Logga ut",
  "oS2fME": "Daglig",
  "OTC+hm": "Svarskrav",
  "ovdjP3": "Filtrera",
  "Ow6ODV": "Förslag",
  "OWJpr4": "Namnge tavla",
  "oWMV+v": "Sök bland alla artiklar",
  "OWxF4v": "Laguppställning",
  "oxM+Os": "Nyckeltal",
  "ozlGXc": "Är du säker på att du vill arkivera \"{title}\"?",
  "P/qdQT": "Bild",
  "p/yGx3": "Senast kontrollerad {time}",
  "P+IlJu": "Magneter",
  "p1rq5g": "Tillåt kameraåtkomst",
  "P6+Bgp": "Storecast",
  "P6KbhZ": "Filnamn",
  "p81mM3": "{used} använda av max {quota} filer.",
  "p8H+A7": "Inga rutiner matchar detta filter.",
  "p9/H6O": "Kunde inte radera användare",
  "PAfIHw": "Välj mål",
  "pATEbd": "Lägg till befintliga kontrollpunkter",
  "PAYg1u": "API nycklar låter externa tjänster skicka data till StoreSprint.",
  "pckk4B": "Extern aktivitet",
  "pClX7u": "Installera ny skärm",
  "Pd2e1I": "Skapa butik",
  "pepmwR": "Lägg till fil",
  "pErsq4": "Ta bort widget från detta Storecast-Space?",
  "pffOt/": "Underschema",
  "pFS7BE": "Webbhämtare",
  "pFveyE": "Skicka viktiga eller akuta meddelanden till valfri enhet i ditt workspace med en Signal. Spåra vem som ser dina meddelanden i realtid. Signaler med prioritetsnivå \"Akut\" visas överst på appens startsida och inkluderar push-notiser för att påkalla mottagarnas uppmärksamhet.",
  "pFvn4k": "Radera tagg",
  "Ph6R7C": "Länka produkt",
  "phnKBJ": "Facebook-länk",
  "pHwbmo": "Använd mål",
  "pIuj1D": "Se mer",
  "pjmhYa": "Lunchrum",
  "PJOr98": "Redigera att göra",
  "PkmVPm": "Veckoblad",
  "PLAewT": "Skapade",
  "pMQ/et": "Lägg till mätområden",
  "PmVGpP": "Användare och enheter",
  "pnwclp": "Anpassade Listor",
  "PnWJFW": "Aktiv profil (Gruppkonto)",
  "PO8dVc": "Datum för arkivering",
  "pPmZLz": "Signage",
  "pprhG/": "Produkter",
  "pqPgm4": "Radera",
  "pqYvsE": "Användare",
  "PrAOWA": "Skicka till {storeCount, plural, one {1 enhet} other {# enheter}}",
  "PsbOYf": "Klar",
  "ptoz9y": "Logga in med ett till konto på samma enhet",
  "pv8cjM": "Veckodag",
  "Pve4Ld": "Avbryt publicering",
  "PvkJMK": "Redigera tagg",
  "pWQJYw": "Skickad {sentAt}. Giltig till {expiresAt}.",
  "Pxuu6l": "Installera ny skärm",
  "PXXYdT": "Välj avdelningar",
  "pykTvD": "Hur kan vi bli bättre?",
  "pZMRGW": "Akut",
  "pzPOqm": "Rutiner Överblick",
  "q+BrXL": "Arkiverade checklistor",
  "q1ICZP": "Inga tilldelade avdelningar",
  "Q1w2zP": "Vilken tavla ska visas på den här skärmen?",
  "Q4+ShE": "Veckovis",
  "q7hSVS": "Skapa nyckeltal",
  "Q8O9gG": "Analys",
  "q9kXY3": "Storlek",
  "QBg+Q6": "Fyll i dagens värde",
  "QbnyCX": "Lämna dina kontaktuppgifter så återkommer vi till dig så snart som möjligt.",
  "QC+Zgu": "Radera checklista",
  "QcEZ9P": "Här syns alla avvikelser som rör {teamName}",
  "qcKrnx": "Roll",
  "qCtGcY": "Hjälp oss bli bättre genom att berätta vad du tycker.",
  "QD6ay0": "Kasta dina ändringar",
  "qeXrKG": "{unAssignedTypes, plural, one {Ett kostnadsställe är inte tilldelat till en avdelning} other {{unAssignedTypes} kostnadsställen är inte tilldelad till någon avdelning}}",
  "Qf1qZG": "Det gick inte att skapa rollen. Försök igen.",
  "qHlota": "Exportera",
  "qhwePS": "Uppdatera mall",
  "QIV+ws": "Lägg till fil",
  "qL00lU": "Stäng",
  "qn3W8E": "Ett telefonnummer för kunder att kontakta dig.",
  "Qo9SjV": "T.ex. \"Fotografera de nya skyltarna i butiken.\"",
  "QPgW0w": "Alla widgets kommer att raderas",
  "qQDnB7": "Välj butik",
  "qqErPY": "Är du säker på att du vill radera detta utkast? Åtgärden går inte att ångra.",
  "QRnvOl": "E-post",
  "qS4Lv/": "Hoppa över",
  "QsF+iU": "Är du säker på att du vill gör om detta konto till ett gruppkonto?",
  "Qun8Jw": "Här går det att skapa rutiner som är frivilliga för enheterna att lägga till och redigera.",
  "qV8/Uv": "Denna sektion kommer endast att vara synlig för enheter som är tilldelade till detta ämne. Om ett eller flera avdelningar prenumererar på ämnet, kommer avvikelser som skapas i denna sektion automatiskt att delas till de avdelningarna.",
  "QvlVSf": "Nästa",
  "qWncnv": "Tilldelat mig på avd.",
  "QWX+g+": "välj datum",
  "Qxh33Z": "Arkiverade avdelningar",
  "QXY5J0": "Lägg till",
  "qyPAqL": "Workspace namn",
  "QzPVom": "Avbryt",
  "QZwFJF": "Kontrollpunkter med flest avvikelser",
  "R//KID": "Du kan också söka efter innehållet i filer!",
  "r/bXMB": "<b>{missingOccasions}</b> missade förra månaden",
  "R1h1Ap": "Inkorgar för medarbetare",
  "r2QTSl": "Tillåt enheter att lokalt dölja",
  "r3Pa3S": "Är du säker på att du vill radera \"{storecastTitle}\"?",
  "R6RUUb": "Radera lista och flytta innehållet till Att Göra",
  "r7Ds/0": "Problemanalys",
  "R8Ku7l": "Nya artiklar inne på Frukten!”",
  "RAC0zJ": "Vilken skärm ska användas?",
  "rbGzBo": "Varumottagning",
  "rC5mA+": "Tillfälle:",
  "Rd8e0A": "Hämtar senaste{newLine} produktinformationen",
  "rF1cLJ": "Status",
  "RFx/l5": "Skapa attribut",
  "Rg5BZj": "Radera användare",
  "RH3rSo": "Obegränsad tillgång till alla funktioner.",
  "RhLB4g": "Integration",
  "rhS+QC": "Kom igång med nyckeltal!",
  "RHZtK5": "Butiksnamn",
  "rJ8lmR": "Lägg till medarbetare",
  "RJkNuL": "Check",
  "RjVWWK": "Används av andra avdelningar",
  "rKO2/c": "Kalender",
  "RKwmCT": "Extern Tjänst",
  "rlQaMu": "Skapa ny mall",
  "rMBr3m": "Instruktioner för att länka en Outlook-kalender",
  "Rmclhs": "Koppla till skärm",
  "RnRN58": "Väder",
  "RNY4Ol": "Inga signaler än, håll ut!",
  "RO95VC": "Integrationer",
  "RoGO3w": "Genom att konvertera detta konto till ett gruppkonto kan du hantera flera anställda under ett enda konto. Detta är användbart för att hantera ett team av anställda eller för att skapa ett delat konto för en grupp användare.",
  "RPrlwI": "Skapa nyckel",
  "rqZZHe": "V. {value}",
  "RR90Yu": "Ta bort användare",
  "RS6oiC": "Filter",
  "rSCrsq": "Tillgång",
  "rt5550": "Skyltning & Gavlar",
  "rTAkF6": "Inget underschema valt",
  "rtckx/": "Lägg till filer!",
  "RTL5iv": "Aktiva användare",
  "rU/S/D": "Länka medarbetare",
  "rVRXH8": "Spann:",
  "rW3SZ/": "Välj kontrollpunkter",
  "rwMH2I": "Topplista",
  "RxnjmX": "Allmänt",
  "RxO4/k": "Ny",
  "rZ0WDi": "Visa fil",
  "rZxOk9": "Information",
  "s+NcRP": "Schemalägg arkivering",
  "s+utOU": "Fritext",
  "s0YLvG": "Uppladdad",
  "s3DVCW": "Över",
  "s7oTCf": "Fotografera",
  "s9+a1w": "Ikon",
  "s9rxG9": "Utan roll",
  "SahLRB": "Installerade",
  "sCzV6w": "Kundfokus",
  "sddrqd": "{count, plural, one {Admin} other {Admins}}",
  "SDedv8": "Aktiv nu",
  "sdLT8G": "Ladda upp flera bilder i samma widget för att skapa ett bildspel. I Fokusläget kan ni se bilderna i helskärm.",
  "SDVhpg": "Visa väderleksrapporten för att påminna om kundflöden och försäljning som påverkas av vädret",
  "se/Ya+": "Tilldelade roller",
  "SEDs1C": "Tavlor",
  "sF+1tG": "Ändra kalender",
  "sFn2s1": "Visar aktiva signaler ordnade efter prioritet",
  "sgif9e": "Namnlös Butik",
  "sGM2sc": "Vill du ta bort det här nyckeltalet?",
  "sgqkck": "Senast aktiv",
  "sIKkvn": "Osparade förändringar",
  "siVFF+": "Vill du skapa en rutinmall i workspace från baserat på den här rutinen?",
  "siWwUW": "Lagringsutrymmet är fullt. Radera filer för att ladda upp nya.",
  "sjt7RB": "Fotografera resultatet",
  "SlswQK": "Gå tillbaka",
  "Sn7TIh": "Acceptera inbjudan från {orgName}",
  "sOigWw": "Skapa ny enhet från denna enhets struktur",
  "SORuxO": "Workspace",
  "sQMyVg": "Ta bort integration",
  "SQtVel": "Är du säker på att du vill ta bort denna kontrollpunkten?",
  "SQXL2J": "Skapa avdelning",
  "SRiqXu": "Serienummer: {serialNumber}",
  "srteJa": "Vill du uppdatera {templateName} med gjorda ändringar?",
  "Sto03R": "Välj vilka taggar som ska bli valda automatisk när en extern aktivitet läggs till",
  "Stv72D": "Mindre än",
  "sU4TQV": "Vill du skapa en mall med befintligt innehåll, inklusive beskrivning, prioritet, svarskrav, bilder och filer?\nLänkade produkter, deadline, notiser och mottagare kommer inte att sparas i mallen. ",
  "SuEqCE": "Radera mätområde",
  "SUlI+n": "Skapa en extern aktivitet",
  "SuQfQ5": "Visa detaljer",
  "SXbo5l": "Rapporterade avvikelser",
  "Sxvo34": "Instruktioner",
  "Sz1dUs": "Skippa",
  "SZA7Xd": "Sök produkter",
  "SzDLWp": "Webbläsarversion",
  "T/h2kF": "Ändra bild",
  "t/l07p": "Avbryt",
  "t+ahDA": "Arkiveras {date}",
  "t0YG4W": "Vill du radera mallen  {templateName}? Du kan inte ångra ditt val.",
  "t4cf6x": "Rensa filter",
  "T72Ckw": "Idag 22:0x0",
  "t8lmJO": "När ska nyckeltalet fyllas i?",
  "T8y+5N": "Skapa",
  "TBkRh6": "Butiksadmin",
  "tBpWyi": "Ta bort underavdelning",
  "TC7emj": "Granska",
  "tcHrO/": "Specificera ditt filter för att välja särskilda butiker, eller välj alla genom att fortsätta.",
  "TCIyYN": "Ta emot dagens leverans vid lastkajen.",
  "tf4qLE": "Butikstavla",
  "tg2T7E": "Deadline",
  "TGY6bH": "Kontonamn",
  "THbR7U": "Avbryt",
  "ThZe2e": "Inställningar för nyhetsflöde",
  "tifuHD": "Standard",
  "TIVrne": "Telefonnummer",
  "TJF3C5": "Radera fil",
  "TJoceO": "Välj tavla",
  "tkEu5x": "Leta efter uppdateringar",
  "tlkN9u": "Avbryt",
  "Tmc9m1": "Säkerställ den dagliga driften med dagligen, veckovis och månatligt återkommande checklistor. Följ upp status för enheterna inom ert workspace i realtid.",
  "To45TA": "Radera skärm",
  "tpUXws": "Installera ny skärm",
  "tQXDmt": "Aktivera StoreSprint Connect",
  "Tr2cGj": "Ingen vald",
  "tRg0W8": "Samla alla som är plats stäm av vad som är prio för dagen och kör morgonmöte vid digitala styrtavlan.",
  "TRpvdA": "Installera skärm",
  "trUNzs": "Användare med mest aktivitet",
  "trzje0": "Alla Tillfällen",
  "TUsgpA": "Roll",
  "tVCZG8": "Lägg till bild",
  "TVKLKA": "Redigerad {relativeTime}",
  "tvT/8m": "Radera mall",
  "tvwrBd": "Nyckeltalen hjälper er att enkelt få en översikt på exempelvis “svinn” och “hål i hyllan”. Utifrån dessa går det att se var förbättringar kan ske.",
  "tWlqKZ": "Kunde inte bjuda in användare",
  "TX8q/7": "Håll koll på händelser med kalender!",
  "TzhFLt": "Kalendrar",
  "u1aoKY": "Välj Tavla",
  "u2hG9M": "Bildspelshastighet",
  "U360Ur": "Installera ny skärm",
  "U4tJB4": "Månader",
  "u56GF0": "Alla enheter & avdelningar",
  "u6Y8Sa": "Totalt",
  "u6ZtUT": "Att arkivera denna aktivitet kommer att ta bort den från din lista över aktiva uppgifter, men den kommer inte att raderas permanent. Du kan fortfarande komma åt den i arkivet senare.",
  "u84wtd": "Inga produkter matchar sökningen {searchText}",
  "u96mop": "Fryslager",
  "uAWZlE": "Rensa",
  "uCcU4l": "Välj kalendrar",
  "UCexA+": "Lägg till deadline",
  "udLtXc": "Obligatorisk",
  "UdQCAN": "Filer",
  "uEioAT": "Radera {todoCategoryName} och flytta innehållet till Att Göra",
  "uf5uTz": "Tillbaka till huvuduppgift",
  "ugJl/L": "Skapa sektion",
  "ugT6Di": "Vill du logga in med ditt personliga konto istället?",
  "UgWg8s": "Prioritet",
  "uGxB+c": "Kan döljas lokalt",
  "UhmZCQ": "Svinn",
  "UHrLsk": "Håll er till schemalagda lunchtider så att butiken alltid är bemannad.",
  "ujeNv1": "Ladda upp filer",
  "UjJ9XM": "Se tavlorna enkelt genom att koppla till en eller fler skärmar.",
  "ujlMWO": "Tid",
  "ul1thl": "Månadsrutiner",
  "uMAhJp": "URL för prenumeration",
  "UmCs/s": "Tillåt kameraåtkomst",
  "uNa9AV": "Uppdateras på: {storecasts}",
  "UondRJ": "Ändra butik",
  "uP6trv": "Uppdatera StoreSprint",
  "uq2k/K": "Inga avvikelser!",
  "uq5b6B": "Ansvarig användare",
  "uQ7LYL": "Kontrollpunkter",
  "Uqh3N1": "Tilldela kostnadsställen",
  "UR4BWI": "Bjud in igen",
  "us/doa": "Vill du inte skapa ett personligt konto? Lägg till en delad enhet istället.",
  "Usu5Z5": "Din nya Storecast, {screenName}, är nu igång!",
  "Ut24+m": "Avbryt",
  "uwx9Jz": "Fortsätt redigera",
  "uX+q73": "Uppladdad",
  "uYEPNd": "Ändra namn",
  "UytNCA": "Uppdatering tillgänglig",
  "uzAD6k": "Tom",
  "uzbmNp": "Kom igång med körschema",
  "UzbmrH": "Avdelningsadmin",
  "UZvM7N": "Skapa Note Widget",
  "v+P2+6": "PLU",
  "v0dXEX": "Avbryt",
  "v0mBka": "Gör en ny tavla",
  "V0Px75": "Sluttid",
  "v4+ROd": "Publicera till {storeCount, plural, one {1 enhet} other {# enheter}}",
  "v48ZvU": "Butiker",
  "V52tMz": "Namn eller Anställnings-ID",
  "V5mAQD": "Visa senast ifyllda status på kontrollpunkter",
  "V7KcmU": "Sparad",
  "V8Xbpm": "Startar vid",
  "v9XXqs": "Skapa en egen kalender eller prenumerera på andra kalendrar för att få in viktiga händelser som kan vara bra att ha koll på.",
  "Ve71mL": "Anpassa checklistan till era behov. Ändra ordning och välj bort valfria sektioner.",
  "vEvOaK": "Ladda upp",
  "vfTZzM": "Använd mall",
  "VG/8zv": "Hittade inte produkt",
  "vgCxIl": "Alla att göra",
  "VghCy3": "Filstorlek",
  "VGU0iY": "Välj kontrollpunkt",
  "VGZx2l": "Öppnad",
  "vhiV6l": "Starttid",
  "vI7Gs4": "Välj profil för att fortsätta",
  "VKOkeJ": "Denna widget visas på flera StoreCast. Den kommer bara bli borttagen från denna StoreCast.",
  "vKRDVP": "Logga in som delad enhet",
  "vkudRz": "Routing",
  "VMND0x": "Vill du ta bort {userEmail} från butiken?",
  "VN8zMb": "Administrera Organisation",
  "vNRcmK": "Skapa ett nytt Storecast-Space",
  "vOy2Hs": "Redigera underavdelning",
  "VrG69L": "Aktivera kassaläget för snabbyte mellan avdelning, filer och PLU",
  "vS5lZ+": "Status",
  "VtiP8W": "Valfri",
  "VTw74p": "Avarkivera",
  "vuKrlW": "Lager",
  "vVvQHI": "Är du säker på att du vill arkivera \"{name}\"? Konton, anställda, delade enheter och skärmar kommer att raderas. Denna åtgärd kan inte ångras.",
  "VwRKdl": "En dold produkt visas enbart i redigeringsläge",
  "vXQmH7": "Sista",
  "Vyu0hX": "Procent av Grön/Röd-kontrollpunkter som har blivit Grön-markerade",
  "VZiS0B": "{numberOfTasks} av {max} kontrollpunkter valda",
  "vZRCu0": "T.ex. \"Rapportera antalet borttagna varor.\"",
  "W/GP+y": "Administrera nyckeltal",
  "w/wKxm": "Text",
  "w+S/15": "Klistra in länk till nyhetsflödet här",
  "w1gT1F": "Veckovis",
  "w3Is48": "Datum och tid visas i workspacets tidszon",
  "W5pg87": "Nyhetsflöde",
  "W6+2YH": "Ge den ett namn",
  "w6bZiI": "Ta bild",
  "w8wRHh": "Välj titel",
  "w9AEBO": "Tackmeddelande",
  "w9Kasw": "Butik",
  "w9Nb+X": "Att Göra-lista",
  "WadF3T": "Kategorier",
  "Wahd+X": "Mål",
  "wckvY1": "Schemalägg",
  "wcqX2V": "Arkivering flyttar denna signal till arkivet och tar bort den från alla mottagarenheter.",
  "WCSIuy": "Vill du radera mallen  {templateName}? Du kan inte ångra ditt val.",
  "WCW6Ye": "Kategori {categoryName} innehåller inga produkter.",
  "wDljGE": "Sök efter adress...",
  "weStML": "Redo att skicka denna uppgift till utvalda butiker? Se till att alla uppgifter är korrekta innan du skickar.",
  "wfcjxy": "Redigerad {relativeTime} av {name}",
  "WfNJXp": "Skapa butik",
  "wfVI2y": "Kontrollpunkt",
  "wFvRpY": "Udda",
  "WHgdsk": "Ej i lager",
  "WhwLe1": "Ladda upp bild",
  "WImx/A": "Inga fler användare att lägga till",
  "WiS3oL": "Sektionsnamn",
  "wJhQVu": "Administrera checklistor",
  "wKGEwd": "Registrerade",
  "wkijyB": "Lyft upp och visualisera goda exempel från verksamheten med bild och text",
  "wKrxLR": "Användning",
  "wlD1mP": "Lägg till butiker",
  "WLY+WO": "Alla avdelningar",
  "WnzMcw": "Namnet på inkorgen som kommer att visas för användaren.",
  "woPNkt": "Utkast",
  "WPBhoc": "Obligatoriskt*",
  "wscCH+": "Före helgen",
  "wvpdgJ": "Admin",
  "WvuPXi": "Låg",
  "WW5l/d": "Ändra namn, färg och ikon",
  "wwqD+1": "Ogiltig QR-kod",
  "wWrkoJ": "Uppdatera mall",
  "wX1flm": "Annat",
  "wyb1Jh": "Kunde inte uppdatera namn",
  "wzEsl3": "Slutförda",
  "x/zeK8": "Ogiltig EAN8. Använd skanner för andra format.",
  "X1Iq9M": "Pass",
  "X2tk8X": "Schema",
  "x5rAgo": "Totalt",
  "X8xKPs": "Ansvariga",
  "XAArsO": "Aktivera",
  "xaPrm5": "Laddar ner uppdatering",
  "xAxvmA": "Språk",
  "xbsw0M": "Skapa eget nyckeltal",
  "xDDcXI": "Bekräfta att du vill radera {todoCategoryName} och flytta innehållet till Att Göra. {totalCount} uppgifter kommer att flyttas.",
  "xdnA0P": "Hemsidans färg",
  "XDSnxE": "Ämne",
  "xeJT7s": "QR-kod till er hemsida",
  "xErulX": "Namnge skärm",
  "XEVqcC": "Välj mall",
  "xfKy3C": "Ersätt",
  "xfps4z": "Fyll i för {relativeTime}",
  "xFT0kK": "Lägg till i rutinbiblioteket (workspace)",
  "xHfUS4": "Ladda upp",
  "xjjVcU": "Lägg till e-postadresser för att bjuda in användare till butiken. {br}Separera flera adresser med kommatecken.",
  "XK4sJE": "En tavla hjälper till att visualisera bland annat nyckeltal, aktiviteter, avvikelser, dagens positiva. Tavlan skräddarsys utefter behoven och går att visas på flera skärmar.",
  "XL0/FH": "Lunch",
  "xNPq4u": "Allt under kontroll",
  "xoZikh": "Storecast Spaces",
  "Xp5AAC": "Lägg till integrationer",
  "xPxDzy": "Notis skickad till {count, plural, one {# enhet} other {# enheter}}",
  "XQnhWg": "Välj avdelningar att mäta på",
  "XQNO3K": "QR-kod är ett enkelt sätt för kunden att navigera till er hemsida.",
  "XR2MFN": "Grupperat på avsändare",
  "Xu2RJf": "Jämna",
  "xu5sb3": "Normal",
  "Xu7Jko": "Den här nyckeln visas bara en gång. Kopiera den och dela endast med betrodda parter.",
  "xV0FDB": "Skapade avvikelser",
  "XViMkH": "Vill du uppdatera {templateName} med gjorda ändringar?",
  "xwEh4R": "Ange en titel för att kunna spara.",
  "xXio3x": "Avdelningen har inga dagliga rutiner på dom valda dagarna.",
  "XXqLc6": "Utgångsdatum",
  "xYpIi/": "Ta bort",
  "Y+C4lt": "Lämna in",
  "y27M75": "Arkiveras {date}",
  "Y4hPi5": "Inställningar för bokaklipp",
  "Y9hMqR": "Möt och hjälp kunder ute i butik. Vid lågt tryck åtgärda avvikelser från dagrundan.",
  "YaC8vJ": "Workspace tillgång och roller ärvs av alla workspaces nedanför",
  "YAirKe": "Ta bort underavdelning",
  "yakL0B": "Ändra roll",
  "yaV88k": "Påminn ej slutförda enheter",
  "yBmdEI": "Laddar historik",
  "ycDO6k": "Ta bort integrationen",
  "YCG9T+": "Är du säker på att du vill gör om detta konto till ett personligt konto?",
  "YCSTK6": "Logga in",
  "YCVhR7": "{day, selectordinal, =0 {#} one {#a} two {#a} few {#e} other {#e} }",
  "YDpFmT": "Tillgång",
  "YDStN7": "Admins har behörighet till alla låsta avdelningar",
  "YeCSPc": "Användare",
  "YEPpPX": "Skapa avdelning",
  "Yf3nSx": "Lägg till bild",
  "yhF9ku": "Entré",
  "Yib5ZV": "Inga produkter hittades i sökningen.",
  "yImf8X": "Temafärg",
  "YJNCD2": "Månadsvis",
  "YJZo0t": "Skapa avvikelse",
  "YldYxG": "Meddelande som visas efter att användaren har skickat in sitt svar",
  "Ym1nxV": "Fortsätt som",
  "YNNEQd": "Sök på namn, PLU eller EAN. Resultat visas från alla kategorier.",
  "yPYEME": "Förhandsvisning",
  "yq9opF": "Rutinmallar",
  "yQcxFe": "Admins",
  "yr+UdN": "skapade",
  "YRx6wA": "Publicera nu",
  "yS4rqx": "Listnamn",
  "yT47yk": "Radera Utkast",
  "YTvQvD": "Skapa ny extern aktivitet",
  "ytzb5J": "Den ansvariga avdelningen kommer att se nyckeltalen från alla andra avdelningar. Det är oftast jour eller ledningen som ska markeras som ansvarig.",
  "yve5Gf": "Snyggt! Setup är nu klart.",
  "YVoQzI": "Utgångsdatum",
  "yY7sJP": "Ogiltig EAN13. Använd skanner för andra format.",
  "YZHvwn": "Skapa nyckeltal",
  "YZNxu1": "Namn",
  "Yzqn4z": "Näst sista",
  "Z+gyc7": "Du har inget tilldelat",
  "Z1e+6H": "Läs mer",
  "Z4rU45": "Skapa checklista",
  "Z6HGta": "Butiksnamn",
  "z6LWcQ": "Får ej plats",
  "Z7TqW7": "Beskrivning",
  "z9kMhA": "Fokusläge",
  "z9quQ4": "Avaktivera Integration",
  "za4kx5": "Webbhämtare",
  "ZaCXLI": "Ny kollega på lagret, välkommen Mathias!",
  "zBN89l": "Länkat",
  "ZCgny/": "Gruppkonto",
  "ZcP7rT": "Snitt",
  "ZdVt3t": "<b>{missingOccasions}</b> missade igår",
  "zE4ecc": "Inga fler användare att lägga till",
  "zEBNcw": "Alla arkiverade",
  "Zejy8c": "Skapa underavdelning",
  "zFBFFg": "Mer",
  "zfKN2G": "Aktiva avvikelser",
  "zGbGoH": "Dagrunda",
  "Zgbwp5": "Är du säker på att du vill radera detta konto?",
  "zgEYmk": "Visa live körschema som uppdateras efter dag, tid och avdelning",
  "Zgoi2g": "Publicera Signal",
  "ZgvLGm": "Inga arkiverade checklistor tillgängliga. När en checklista arkiveras kommer den att visas här.",
  "Zh90tv": "Uppdatera",
  "ZHcR81": "Senaste IP",
  "ZhcZ9q": "Se mer",
  "zilTRu": "Välj ett namn som passar det avsedda syftet med innehållet.",
  "ZJbdQ0": "Namn",
  "Zjd8I0": "Lycka till med användningen av StoreSprint! Du kan besöka {learn} för en snabb genomgång. Kontakt oss via {contact}.",
  "ZKihht": "Email",
  "ZKxre4": "Produkten är redan tillagd",
  "zLAbbT": "Här var det tomt!",
  "ZlxuTF": "Checklistan har ingen historik ännu",
  "ZMBIQ1": "Aktuella avvikelser",
  "zMQr0I": "Inga utgångsdatum som kräver din uppmärksamhet.",
  "zMXgF7": "Startar",
  "ZN/xRM": "Välj minst 1 aktiv vecka",
  "ZNB+C6": "Skapa nyckel",
  "zOLHVm": "Nytt svar",
  "zp5CAq": "Ändra",
  "zq1Q34": "Sparad <date>{editedAtDate}</date> av {editedByName}",
  "zqj7G7": "Mallar",
  "zQJkiy": "Inställningar",
  "ZqPkj3": "Aktivitetskategori",
  "ZqtZai": "Låst Ämne",
  "ZrAW38": "Anteckningar ni redan har skapat kan läggas till på flera tavlor. Skapar ni en widget med \"Text och Bild\" kan den läggas till på era befintliga tavlor. På så sätt kan ni enkelt dela och återanvända anteckningar.",
  "ZSRXqK": "{numOfTasks} av {maxNumOfTasks} kontrollpunkter",
  "zUIE28": "Hög",
  "zUlhDu": "Är du säker på att du vill ta bort denna kommentar?",
  "zUXwEv": "Avdelning",
  "zV/gxP": "Använd mall",
  "zXlzQR": "Allmänt",
  "ZXxU5D": "Checklista Status",
  "zXyOZC": "Skapa anpassad lista",
  "ZYh06E": "Ansvarig avdelning: {assignedTeamName}",
  "ZyJyqm": "Eller gör det sen",
  "zYXGIO": "Inbjudan har löpt ut"
}